/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
/* eslint object-curly-newline: ["error", { "multiline": true }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import lodash from 'lodash';
import axios from 'axios';
import qs from 'qs';

// initial state
const state = {
  downloadInProgress: false,
  vendors: [],
  featuredVendors: [],
  loaders: {
    vendors: false,
  },
  initializers: {
    vendors: false,
  },
};

// getters
const getters = {
  vendors: (state) => lodash.sortBy(state.vendors, [(vendor) => lodash.lowerCase(vendor.name)]),
  featuredVendors: (state) => lodash.sortBy(state.featuredVendors, [(vendor) => lodash.lowerCase(vendor.name)]),
  downloadInProgress: (state) => state.downloadInProgress,
  member_id: (state, getters, rootState, rootGetters) => rootGetters['main/member_id'],
  loaders: (state) => state.loaders,
  initializers: (state) => state.initializers,
  audiologyVendors: (state, getters) => lodash.filter(getters.vendors, (vendor) => vendor.category === 'Audiology'),
  allergyVendors: (state, getters) => lodash.filter(getters.vendors, (vendor) => vendor.category === 'Allergy & Sinus'),
  practiceManagementVendors: (state, getters) => lodash.filter(getters.vendors, (vendor) => vendor.category === 'Practice Management & Software Solutions'),
  financeVendors: (state, getters) => lodash.filter(getters.vendors, (vendor) => vendor.category === 'Finance & Merchant Solutions'),
  categorizedVendorIDs: (state, getters) => lodash.map(lodash.concat(getters.audiologyVendors, getters.allergyVendors, getters.practiceManagementVendors, getters.financeVendors), 'id'),
  otherVendors: (state, getters) => lodash.reject(getters.vendors, (vendor) => getters.categorizedVendorIDs.includes(vendor.id)),
  categoriesUsed: (state, getters) => lodash.concat(getters.audiologyVendors, getters.allergyVendors, getters.financeVendors, getters.practiceManagementVendors).length > 0,
};

// actions
const actions = {
  getVendors({ commit }) {
    commit('TOGGLE_LOADING', { key: 'vendors', value: true });
    return axios.get(`${CONFIG.get('BASE_URL')}/api/vendors/`)
      .then(({ data }) => {
        commit('SET_PROPERTY', { key: 'vendors', value: data.vendors });
        commit('SET_PROPERTY', { key: 'featuredVendors', value: data.featuredVendors });
        commit('TOGGLE_LOADING', { key: 'vendors', value: false });
        commit('TOGGLE_INITIALIZED', { key: 'vendors', value: true });
      });
  },
  setProperty({ commit }, payload) {
    commit('SET_PROPERTY', payload);
  },
};

// mutations
const mutations = {
  SET_PROPERTY(state, payload) {
    state[payload.key] = payload.value;
  },
  TOGGLE_LOADING(state, payload) {
    state.loaders[payload.key] = payload.value;
  },
  TOGGLE_INITIALIZED(state, payload) {
    state.initializers[payload.key] = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
